require('./expensesByCategoryInfo.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    Component
} = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
// const ExpensesByCategoryComparativeBars = require('../expensesByCategoryComparativeBars/expensesByCategoryComparativeBars');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKIconCategorization } = require('commonsComponents/OKIconCategorization');

// @constants
const { getCategoryIcon } = require('constants/categories');

class ExpensesByCategoryInfo extends Component {
    render() {
        const { category, onOpenFilter, filter, onHandleClearFilter/*, totalExpenses, totalExpensesByCategory*/ } = this.props;

        const categoryIcon = getCategoryIcon(category);

        return (
            <div className="container-fluid">
                <div className="row expenses-by-category-info__content">
                    <div className="col-xs-12 col-md-8">
                        <span className="expenses-by-category-info__content__title">
                            <OKIconCategorization activeHover={false} icon={categoryIcon} size="large" />
                            <div className="expenses-by-category-info__content__text">
                                {formatText('categories-'+category)}
                            </div>
                        </span>
                    </div>
                    <div className="col-xs-12 col-md-4 expenses-by-category-info__buttons">
                        {filter &&  <button className="expenses-by-category__button-clean" onClick={onHandleClearFilter}>
                            <FormattedText value="filters-clean" />
                        </button>}
                        <OKButton
                            id="btn_accountLastMovementsHeader_filterButton"
                            modifier="task"
                            onClick={onOpenFilter}>
                            <i className="icon icon-filtrar expenses-by-category--filter-settings-icon" />
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }
}

ExpensesByCategoryInfo.propTypes = {
    category: PropTypes.string,
    categories: PropTypes.array,
    filter: PropTypes.bool,
    totalExpenses: PropTypes.number,
    onHandleClearFilter: PropTypes.func,
    totalCategoryExpenses: PropTypes.object,
    totalExpensesByCategory: PropTypes.number,
    onOpenFilter: PropTypes.func
};

module.exports = ExpensesByCategoryInfo;
